export default __webpack_public_path__ + "static/media/Emily.91579236.png";